/**
 * Gold sparkle cursor trail — luxury jewellery brand effect.
 * Spawns tiny gold/diamond sparkle particles that drift and fade behind the cursor.
 * Desktop only, respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.style.cssText =
    'position:fixed;inset:0;pointer-events:none;z-index:999999;width:100%;height:100%';
  document.body.appendChild(canvas);

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var particles = [];
  var mx = -100, my = -100;
  var lastX = -100, lastY = -100;
  var raf;
  var COLORS = ['#d4af37', '#c8a84b', '#f5e6a3', '#fff8dc'];
  var MAX = 15;

  function resize() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  function onMouseMove(e) {
    mx = e.clientX;
    my = e.clientY;
  }
  document.addEventListener('mousemove', onMouseMove);

  function spawn() {
    var dx = mx - lastX;
    var dy = my - lastY;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 12) return;
    lastX = mx;
    lastY = my;

    if (particles.length < MAX) {
      particles.push({
        x: mx + (Math.random() - 0.5) * 6,
        y: my + (Math.random() - 0.5) * 6,
        vx: (Math.random() - 0.5) * 0.8,
        vy: -Math.random() * 1 - 0.2,
        size: Math.random() * 2 + 0.8,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        life: 1,
        decay: 0.025 + Math.random() * 0.02,
        angle: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.12
      });
    }
  }

  function drawStar(x, y, r, a) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(a);
    ctx.beginPath();
    for (var i = 0; i < 4; i++) {
      var ang = (i * Math.PI) / 2;
      ctx.moveTo(0, 0);
      ctx.lineTo(Math.cos(ang) * r, Math.sin(ang) * r);
    }
    ctx.stroke();
    ctx.restore();
  }

  function tick() {
    ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);
    spawn();

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.02;
      p.life -= p.decay;
      p.angle += p.spin;

      if (p.life <= 0) {
        particles.splice(i, 1);
        continue;
      }

      var alpha = p.life * p.life;
      ctx.globalAlpha = alpha;
      ctx.strokeStyle = p.color;
      ctx.lineWidth = 0.8;
      drawStar(p.x, p.y, p.size, p.angle);
    }

    ctx.globalAlpha = 1;
    raf = requestAnimationFrame(tick);
  }

  raf = requestAnimationFrame(tick);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      cancelAnimationFrame(raf);
      document.removeEventListener('mousemove', onMouseMove);
    } else {
      document.addEventListener('mousemove', onMouseMove);
      raf = requestAnimationFrame(tick);
    }
  });
})();
